module.exports = __webpack_public_path__ + "4b07bcb2f9f90bda850981e3512bcd45.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/15_D3.mp3
// module id = 114
// module chunks = 0